import React from "react";
import PropTypes from "prop-types";

// local component imports
import DynamicGrid from "../../GenericComponents/DynamicGrid";
import DynamicCarousel from "../../GenericComponents/DyamicCarousel";

// services and utils imports
import { LAYOUT_TYPE } from "../../../../../constants/pageConstants/dynamicHomeConstants";

/**
 * CollectionWidget renders a collection as a grid or carousel layout.
 * @param {object} props - Component props
 * @param {object} props.widget - Widget configuration object
 * @param {boolean} props.isAboveFold - Whether this widget is expected above the fold
 * @param {boolean} props.isLcpCandidate - Whether this widget may contain the LCP image
 * @returns {React.ReactElement} The rendered collection widget
 */
const CollectionWidget = ({ widget, isMobile, isAboveFold = false, isLcpCandidate = false }) => {
  const layoutType = widget.layoutSnapshot?.type;

  const sectionPadding = {
    paddingLeft: `${widget.sectionSettings?.padding?.left || 0}px`,
    paddingRight: `${widget.sectionSettings?.padding?.right || 0}px`,
  };

  if (layoutType === LAYOUT_TYPE.GRID) {
    return (
      <div
        style={{
          ...sectionPadding,
          paddingTop: isMobile ? "0px" : "20px",
          paddingBottom: isMobile ? "0px" : "20px",
        }}
        id={`collection_widget-grid`}
      >
        <DynamicGrid
          layoutSnapshot={widget.layoutSnapshot}
          sectionSettings={widget.sectionSettings}
          isMobile={isMobile}
          isAboveFold={isAboveFold}
          isLcpCandidate={isLcpCandidate}
        />
      </div>
    );
  } else if (layoutType === LAYOUT_TYPE.CAROUSEL) {
    return (
      <div id="collection-widget-carousel">
        <DynamicCarousel
          layoutSnapshot={widget.layoutSnapshot}
          sectionSettings={widget.sectionSettings}
          isMobile={isMobile}
          isAboveFold={isAboveFold}
          isLcpCandidate={isLcpCandidate}
        />
      </div>
    );
  }
  return <></>;
};

CollectionWidget.propTypes = {
  widget: PropTypes.object.isRequired,
  isMobile: PropTypes.bool.isRequired,
  isAboveFold: PropTypes.bool,
  isLcpCandidate: PropTypes.bool,
};

export default CollectionWidget;
